import {
  EditOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Box, Flex, IconButton } from "@strapi/design-system";
import { Button, Modal, Table, message, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReferralEmail from "../form/ReferralEmail";

const ReferralEmailTab = ({
  dataForUpdate,
  setDataForUpdate,
  isSecretariatView = false,
}) => {
  const { t, i18n } = useTranslation();
  const userInfo = useSelector((state) => state.app.userInfo);
  const [messageApi, contextHolder] = message.useMessage();
  const emptyData = {
    key: null,
    name: null,
    file_name: null,
    file_id: null,
  };

  const [currentPage] = useState(1);
  const [pageSize] = useState(25);

  const [showModal, setShowModal] = useState(false);

  const [selectedData, setSelectedData] = useState(emptyData);
  const emails = [
    {
      key: 1,
      name: `${
        userInfo?.nominator?.is_org === true
          ? t("str_letter_recommendation_organization")
          : t("str_recommendation_letter_1")
      }`,
      url: "",
      file_name: "",
      file_id: null,
    },
  ];
  const [referralEmails, setReferralEmails] = useState(emails);

  const columns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_referral_email")}`,
      dataIndex: "name",
      render: (value, record) => (
        <span>
          {`${t("str_recommendation_letter")} ${record.key.toString()}`}
          {record.key === 1 && (
            <span style={{ color: "red", marginLeft: 4 }}>*</span>
          )}
        </span>
      ),
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        if (record?.url !== null && record?.url !== "")
          return (
            <a
              href={record?.url}
              download={record?.file_name}
              target="_blank"
              rel="noopener"
            >
              {record?.file_name ?? record?.url}
            </a>
          );
        return <span>{record?.file_name}</span>;
      },
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView) {
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() => handleShowModal(record)}
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              {record.key > 1 && (
                <Box paddingLeft={1}>
                  <Popconfirm
                    onConfirm={() => handleDelete(index)}
                    title={t("str_confirm")}
                    description={t("str_confirm_delete")}
                    okText={t("str_yes")}
                    cancelText={t("str_no")}
                  >
                    <IconButton noBorder icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Box>
              )}
            </Flex>
          );
        }
        return null;
      },
    },
  ];

  useEffect(() => {
    getData();
    setShowModal(true);
    setShowModal(false);
  }, []);

  const getData = () => {
    let temp = [];
    temp = [...referralEmails];
    if (
      dataForUpdate?.referral_emails &&
      dataForUpdate?.referral_emails?.length > 0
    ) {
      for (
        let index = 0;
        index < dataForUpdate?.referral_emails?.length;
        index++
      ) {
        const element = dataForUpdate?.referral_emails[index];

        if (temp[index] === undefined) {
          temp[index] = { ...emptyData, key: index + 1 };
        }


        temp[index]["url"] = element?.content?.url;
        temp[index]["file_name"] = element?.content?.name;
      }
      setReferralEmails(temp);
    }
  };

  const uploadFileSuccessCallback = () => {
    let temp = {
      ...dataForUpdate,
      referral_emails: [...dataForUpdate.referral_emails],
    };

    temp.referral_emails[selectedData.key - 1] = {
      ...(temp?.referral_emails?.[selectedData.key - 1] || {}),
      content: selectedData.file_id ?? null,
    };

    setDataForUpdate(temp);

    let arr = [...referralEmails];

    const index = arr.findIndex((x) => x.key === selectedData.key);
    if (index > -1) {
      arr[index].file_name = selectedData?.file_name;
    } else {
      let newItem = {
        key: selectedData.key,
        name: `${t("str_recommendation_letter")} ${selectedData?.key.toString()}`,
        url: "",
        file_name: selectedData?.file_name,
      };

      arr.push(newItem);
    }

    setReferralEmails(arr);
    setShowModal(false);
  };

  const handleAddNew = () => {
    if (dataForUpdate?.referral_emails[0]?.content === null) {
      messageApi.open({
        type: "error",
        content: t("str_please_upload_first_letter"),
      });
      return;
    }

    const key = referralEmails?.length + 1;
    const name = `${t("str_recommendation_letter")} ${key.toString()}`;
    setSelectedData({ ...emptyData, name, key });
    setShowModal(true);
  };

  const handleShowModal = (record) => {
    setSelectedData(record);
    setShowModal(true);
  };

  const handleDelete = (index) => {
    let temp = [...referralEmails];
    temp.splice(index, 1);
    setReferralEmails(temp);

    let updatedData = { ...dataForUpdate };
    updatedData.referral_emails.splice(index, 1);
    setDataForUpdate(updatedData);
  };

  return (
    <div>
      {contextHolder}
      <Box paddingBottom={4}>
        <span className="subnotes">{t("str_minimum_1_letter")}</span>
      </Box>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={referralEmails}
        scroll={{ x: "1000px" }}
        footer={() => {
          if (!isSecretariatView)
            return (
              <Button
                type="link"
                icon={<PlusCircleOutlined />}
                onClick={handleAddNew}
              >
                {t("str_add_references_letter")}
              </Button>
            );
          return null;
        }}
      />

      <Modal
        title={t("str_referral_email")}
        onOk={uploadFileSuccessCallback}
        onCancel={() => setShowModal(false)}
        open={showModal}
        destroyOnClose
      >
        <ReferralEmail data={selectedData} setData={setSelectedData} />
      </Modal>
    </div>
  );
};

export default ReferralEmailTab;
